import _ from 'lodash'
import { AppSpecData, Experiments } from '@wix/thunderbolt-symbols'

const URL_TEMPLATE_MATCHER = /{urlTemplate:(.*)}/

type DataGetterFN = (
	dataPath: string,
	{ clientSpec, serviceTopology }: { clientSpec: any; serviceTopology: any },
	experiments: Experiments,
	metaSiteId: string
) => string

export function resolveAppStudioViewerScriptUrls(
	studioAppSpecs: Array<AppSpecData>,
	serviceTopology: any,
	experiments: Experiments,
	metaSiteId: string
) {
	return _.map(studioAppSpecs, (specData: AppSpecData) => {
		const viewerScriptUrl = _.get(specData, ['appFields', 'platform', 'viewerScriptUrl'])
		const [, viewerScriptUrlTemplate] = URL_TEMPLATE_MATCHER.exec(viewerScriptUrl) || []

		const resolvedViewerScriptUrl = viewerScriptUrlTemplate
			? resolveUrl(viewerScriptUrlTemplate, specData, serviceTopology, experiments, metaSiteId)
			: viewerScriptUrl

		const appData = _.cloneDeep(specData)
		_.set(appData, ['appFields', 'platform', 'viewerScriptUrl'], resolvedViewerScriptUrl)
		return appData
	})
}

function resolveByDataGetter(
	url: string,
	dataSources: any,
	dataGetter: DataGetterFN,
	dataGetterKey: string,
	experiments: Experiments,
	metaSiteId: string
) {
	const matcher = new RegExp(`{${dataGetterKey}:(.*?)}`, 'g')
	return url.replace(matcher, (match, dataPath) => {
		const resolvedData = dataGetter(dataPath, dataSources, experiments, metaSiteId)
		if (!resolvedData) {
			throw new Error(`Data getter '${dataGetterKey}' returned no value for data '${dataPath}'`)
		}
		return resolvedData
	})
}

function resolveUrl(
	url: string,
	clientSpec: AppSpecData,
	serviceTopology: any,
	experiments: Experiments,
	metaSiteId: string
) {
	return _.reduce(
		dataGetters,
		(currUrl, dataGetter, dataGetterKey) =>
			resolveByDataGetter(
				currUrl,
				{ clientSpec, serviceTopology },
				dataGetter,
				dataGetterKey,
				experiments,
				metaSiteId
			),
		url
	)
}

const dataGetters: Record<string, DataGetterFN> = {
	serviceTopology: (dataPath: string, { serviceTopology }: { serviceTopology: any }) =>
		_.get(serviceTopology, dataPath),
	clientSpec: (dataPath: string, { clientSpec }: { clientSpec: any }) => _.get(clientSpec, dataPath),
	appStudioBundler: (dataPath: string, { serviceTopology }: { serviceTopology: any }) =>
		`${serviceTopology.scriptsLocationMap['blocks-client-viewer-app']}/viewerApp.umd.min.js`,
}
